import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const ProductCategoriesRoutes: Routes = [
  {
    path: "product-categories",
    loadComponent: () =>
      import("./product-categories/product-categories.component").then(
        (m) => m.ProductCategoriesComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./product-category-list/product-category-list.component").then(
            (m) => m.ProductCategoryListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./product-category-form/product-category-form.component").then(
            (m) => m.ProductCategoryFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./product-category-form/product-category-form.component").then(
            (m) => m.ProductCategoryFormComponent,
          ),
      },
    ],
  },
];
